export default __webpack_public_path__ + "static/media/inspired-logo.7e97da40.png";